<p class="debugMessage"><small>data-integration-sensors:</small></p>

<div class="tab-content">
	<ng-container *ngTemplateOutlet="sensorNavBar"></ng-container>
	<ng-container *ngIf="filteredSensorsList then mainSensorList"></ng-container>
</div>

<ng-template #sensorNavBar>
	<nav class="navbar navbar-expand-lg alignRow" style="margin-top: var(--default-margin);">

		<span class="alignRow app-icon app-icon--sensors"><mat-icon /></span>

		@if (filteredSensorsList && sensorsList) {
		<span style="padding-left: var(--default-padding);font-weight: bold;font-size: larger;"
			matTooltip="Showing {{filteredSensorsList.length}} of {{sensorsList.length}} Sensors">Sensors&nbsp;({{filteredSensorsList.length}}/{{sensorsList.length}})</span>
		}

		<span style="padding-left: var(--default-padding);">
			<mat-button-toggle-group [value]="showSensors" class="no-tick compact-toggle"
				(change)="toggleButtonGroupFilter($event.value)">
				@for ( btn of BGSelection; track $index) {
				<mat-button-toggle [value]="btn.Id" title="{{ btn.Value }}" [ngStyle]="{'color': btn.Color}">
					@if (btn.Icon) {<mat-icon>{{ btn.Icon }}</mat-icon>}
					@else{<span>{{btn.Value}}</span>}
				</mat-button-toggle>
				}
			</mat-button-toggle-group>
		</span>

		<span class="alignRow app-icon app-icon--refresh" (click)="refreshSensors()"><mat-icon /></span>


		@if (isAdmin(true)){
		<span class="alignRow" style="margin-left: 1em;">
			<span>All Sensors</span>
			<mat-checkbox #topCheckbox color="primary" (change)="toggleAllSensors($event)" color="primary"
				[checked]="allSensorsSelected" [indeterminate]="hasSelectedSensors && !allSensorsSelected"
				(change)="toggleAllSensors($event)" />
		</span>

		<button class="sensor-button" mat-raised-button [disabled]="!hasSelectedSensors"
			[matMenuTriggerFor]="sensorEnableMenu">Enable Selected</button>
		<mat-menu #sensorEnableMenu>
			<button mat-menu-item (click)="enableSelectedSensors(true)">Enable Sensors Only</button>
			<button mat-menu-item (click)="enableSelectedSensors(true, true)">Enable Sensors and DataPoints</button>
		</mat-menu>

		<button class="sensor-button" mat-raised-button [disabled]="!hasSelectedSensors" style="margin-left: 0.5em;"
			(click)="enableSelectedSensors(false)">Disable Selected</button>
		}

		<span class="me-auto"></span>
		<span>
			@if (webhookIntegration && webhookIntegration.NeuronSensors) {
			<button mat-button [routerLink]="['neuronsensors']"><span>Manage</span></button>
			}
			@if (webhookIntegration && webhookIntegration.Type == 'Virtual') {
			<button mat-button [routerLink]="['virtualsensors']"><span>Manage Virtual Sensors</span></button>
			}
		</span>
		<app-filter-box (search)="applyFilter($event)" PlaceHolder="Filter Sensor List" />
	</nav>
</ng-template>

<ng-template #mainSensorList>
	<div class="splittersection">
		<ejs-splitter #horizontal separatorSize=4 width='100%' height='calc(100vh - ( var(--site-navBar-Height) * 2 ) )'
			style="margin-top: var(--default-margin);">
			<e-panes>
				<e-pane size='50%' min='25%'>
					<ng-template #content>
						<div class="leftpanel">
							@if (!filteredSensorsList) {
							<div class="empty-overlay alignRow">
								<mat-icon>search_off</mat-icon>
								<div>No sensors found</div>
							</div>
							}
							@if (filteredSensorsList.length == 0 && sensorsList.length > 0) {
							<div class="empty-overlay alignRow">
								<mat-icon>search_off</mat-icon>
								<div>No sensors found Matching this filter</div>
							</div>
							}
							@if (sensorsList.length == 0 && webhookIntegration.NeuronSensors) {
							<div class="empty-overlay alignRow">
								<mat-icon>search_off</mat-icon>
								<div>No sensors found configured in this Integration</div>
							</div>
							<div class="empty-overlay alignRow">
								<div>Use the <a routerLink="neuronsensors">Manage</a> page to configure sensors from
									NeuronSensors</div>
							</div>
							}
							<ejs-listview class="scrollarea" id='listview-scrolling' #listviewInstance
								[dataSource]='filteredSensorsList' cssClass="e-list-template"
								(scroll)='onListScroll($event)' (actionComplete)="onActionComplete($event)"
								(actionBegin)="actionBegin($event)" (select)="selectSensor($event)">
								@if (!isMobile) {
								<ng-template #template let-dataSource="">
									<div class="ejs-listview-item listview-sensor gridRow"
										[ngStyle]="{'color': !dataSource.Enabled ? 'grey':''}">
										@if (isAdmin(true)) {
										<div class="edit ">
											<mat-checkbox #sensorCheckbox color="primary"
												[(ngModel)]="dataSource._Selected" />
										</div>
										}
										<img class="image"
											(click)="viewImage(imagePathSensors() + dataSource.SensorID + '?' + dataSource.Modified)"
											src="{{imagePathSensors()}}{{dataSource.SensorID}}?{{dataSource.Modified}}"
											alt="{{dataSource.altText}}"
											onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
										<div class="detail">
											<div class="sensorname">
												<span style="margin-right: var(--default-margin);">{{dataSource.Name}}
												</span>
												@if (dataSource.Offline && dataSource.Enabled) {
												<span class="app-icon app-icon--warning">
													<mat-icon title="Sensor Offline" />
												</span>
												}
												@if (!dataSource.Enabled) {
												<span class="app-icon app-icon--sensorOffline">
													<mat-icon title="Sensor Disabled" />
												</span>
												}
												@if (!dataSource.EnableOffline) {
												<span style="color:red">
													<mat-icon
														title="Offline Notifications Disabled">notifications_off</mat-icon>
												</span>
												}
											</div>
											<div id="description" class="description">
												{{dataSource.Description === "" ? "-" : dataSource.Description}}
											</div>
										</div>
										<div class="me-auto"></div>
										@if (dataSource.Enabled) {
										<div class="detail"
											style="text-align: right; padding-right: var(--default-padding);">
											<div class=" lastupdated">
												<span>Last Updated:&nbsp;</span>
											</div>
											<div class=" lastupdated">
												<span>
													<b>{{ !dataSource.Enabled ? 'Disabled' :
														convertEpoch(dataSource.LastValueReceived)}}</b>
												</span>
											</div>
										</div>
										}
										<div class="edit gridHover">
											<span class="app-icon "
												[ngClass]="dataSource.NeuronSensors && isAdmin(true) ? 'app-icon--edit-wizard':'app-icon--edit'"
												(click)="editSensor(dataSource, (dataSource.NeuronSensors && isAdmin(true)))"><mat-icon /></span>
										</div>
									</div>
								</ng-template>
								}
							</ejs-listview>
							<span class="filter-result">
								@if (showSensors != '1') {<span>{{showSensorText}}</span>}
								@if (filterValue != '') {<span>Matching {{filterValue}}</span>}
							</span>
						</div>
					</ng-template>
				</e-pane>
				<e-pane min='25%'>
					<ng-template #content>
						<div class="rightpanel">
							<ng-container *ngIf="selectedSensor then datapointTabs else selectDatapoint"></ng-container>
						</div>
					</ng-template>
				</e-pane>
			</e-panes>
		</ejs-splitter>
	</div>
</ng-template>

<ng-template #selectDatapoint>
	<span>
		<h1>Select a Sensor</h1>
	</span>
</ng-template>

<ng-template #datapointTabs>
	@if (selectedSensor) {
	<div class="alignColumn"
		style="margin-bottom: var(--default-margin);text-align: left;align-items: start;background-color: white;padding: var(--default-padding);">
		<span>
			<h1>{{selectedSensor.Name}}</h1>
		</span>
		<span>Description:&nbsp;<b>{{selectedSensor.Description}}</b></span>
		<span>Last Updated:&nbsp;<b>{{convertEpoch(selectedSensor.LastValueReceived)}}</b></span>
	</div>
	}

	<ejs-tab id="element" headerPlacement="Top" style="margin: 1em;margin-left: 0px;">
		<e-tabitems>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow app-icon app-icon--sensors">
						<mat-icon />
						<span>&nbsp;Datapoints</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointsList"></ng-container>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow app-icon app-icon--asset">
						<mat-icon />
						<span>&nbsp;Linked Assets</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointLinkedAssets"></ng-container>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow app-icon app-icon--rules">
						<mat-icon />
						<span>&nbsp;Linked Rules</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointLinkedRules"></ng-container>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow">
						<mat-icon>sensors</mat-icon>
						<span>&nbsp;Offline History</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointOfflineHistory"></ng-container>
				</ng-template>
			</e-tabitem>
		</e-tabitems>
	</ejs-tab>
</ng-template>

<ng-template #datapointsList>
	<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='sensorDatapoints' cssClass="e-list-template"
		headerTitle="{{selectedSensor?.Name}} Datapoints {{!selectedSensor?.Enabled ? '(Sensor Offline)':''}}"
		showHeader="true" style="min-width: 100%;">

		@if (!isMobile) {
		<ng-template #template let-dataSource="">
			<div class="ejs-listview-item listview-datapoint gridRow"
				[ngStyle]="{'color': !dataSource.Enabled ? 'grey':''}">
				<span class="detail">
					<div class="alignRow name">
						<span>Name:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.PVName}}</b></span>
						@if (dataSource.Offline && dataSource.Enabled) {
						<span class="app-icon app-icon--warning"><mat-icon title="Datapoint Offline" /></span>
						}
						@if (!dataSource.Enabled) {
						<span class="app-icon app-icon--sensorOffline"><mat-icon title="Datapoint Disabled" /></span>
						}
						@if (!dataSource.EnableOffline) {
						<span style="color:red"><mat-icon
								title="Offline Notifications Disabled">notifications_off</mat-icon></span>
						}
					</div>
					@if (dataSource.PVDescription) {
					<div class="alignRow description">
						<span>Description:&nbsp;<b>{{dataSource.PVDescription}}</b></span>
					</div>
					}
					@if (dataSource.SI) {
					<div class="alignRow units">
						<span>Units:&nbsp;<b>{{dataSource.SI}}</b></span>
					</div>
					}
				</span>
				<div class="me-auto"></div>
				@if (checkFeature(AccountFeatures.Sparkle_Line)) {
				<app-sparkle-line [LineData]="dataSource.SparkleLineData" />
				}
				@if (dataSource.Enabled) {
				<span class="detail">
					<div class="lastupdated">
						<span>Last Updated:&nbsp;</span>
					</div>
					<div class="lastupdated">
						<span>
							<b>{{ !dataSource.Enabled ? 'Disabled' :
								convertEpoch(dataSource.LastValueReceived)}}</b></span>
					</div>
				</span>
				}
				<div class="edit gridHover gridMenu"
					style="margin-left: var(--default-margin); color: var(--default-FG-Color);">
					<span class="app-icon app-icon--edit" (click)="editDataPoint(dataSource)"><mat-icon /></span>
					<span class="app-icon app-icon--compare"
						(click)="viewDatapointGraph(dataSource)"><mat-icon /></span>
				</div>
			</div>
		</ng-template>
		}
	</ejs-listview>
</ng-template>

<ng-template #datapointLinkedAssets>
	<div class="listbox-header">
		<span>
			{{ selectedSensor?.Name }} Linked Assets
			@if (!selectedSensor?.Enabled){<span>(Sensor Offline)</span>}
		</span>
		<span class="toolbar-spacer"></span>
		<button mat-raised-button (click)="linkAsset()">Link Asset</button>
	</div>
	<ejs-listview id="listview-scrolling" #listviewInstance [dataSource]="sensorAssets" cssClass="e-list-template"
		style="min-width: 100%;">
		@if (!isMobile) {
		<ng-template #template let-dataSource="">
			<div class="ejs-listview-item listview-datapoint">
				<img class="image"
					(click)="viewImage(imagePathAssets() + dataSource.AssetID + '?' + dataSource.Modified)"
					src="{{imagePathAssets()}}{{dataSource.AssetID}}?{{dataSource?.Modified}}"
					alt="{{dataSource.Name}} - {{dataSource.Description}}"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
				<span class="detail">
					<div class="alignRow name">
						<span>Name:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.Name}}</b></span>
					</div>
					@if (dataSource.Description) {
					<div class="alignRow description">
						<span>Description:&nbsp;<b>{{dataSource.Description}}</b></span>
					</div>
					}
				</span>
				<div class="me-auto"></div>
				<span class="detail" style="padding: 1em;">
					<button mat-raised-button (click)="goToFunctionalLocation(dataSource)" class="app-icon--goto">
						<mat-icon />
						<span>View</span>
					</button>
				</span>
			</div>
		</ng-template>
		}
	</ejs-listview>
</ng-template>

<ng-template #datapointLinkedRules>
	<div class="listbox-header">
		<span>
			{{ selectedSensor?.Name }} Associated Rules
			@if (!selectedSensor?.Enabled){<span>(Sensor Offline)</span>}
		</span>
	</div>
	@if (sensorRules.length > 0 && !isMobile) {
	<ejs-listview id="listview-scrolling" #listviewInstance [dataSource]="sensorRules" cssClass="e-list-template"
		style="min-width: 100%;">
		<ng-template #template let-dataSource="">
			<div class="ejs-listview-item listview-rule">
				<span class="detail">
					<div class="alignRow name">
						<span>Name:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.RuleDescription}}</b></span>
						@if (!dataSource.RuleEnabled) {<small>Disabled</small>}
					</div>
					@if (dataSource.RuleMessage) {
					<div class="alignRow description">
						<span>Message:&nbsp;<b>{{dataSource.RuleMessage}}</b></span>
					</div>
					}
					@if (dataSource.ReadableRule) {
					<div class="alignRow ruleDefinition">
						<span>Rule:&nbsp;<b>{{dataSource.ReadableRule}}</b></span>
					</div>
					}
				</span>
				<div class="me-auto"></div>
				<div class="edit" style="padding: 1em;">
					<button mat-raised-button (click)="getAssetForRule(dataSource)" class="app-icon--goto">
						<mat-icon />
						<span>View</span>
					</button>
				</div>
			</div>
		</ng-template>

	</ejs-listview>
	}
</ng-template>

<ng-template #datapointOfflineHistory>
	<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='sensorOfflineHistory'
		cssClass="e-list-template"
		headerTitle="{{selectedSensor?.Name}} Offline History {{!selectedSensor?.Enabled ? '(Sensor Offline)':''}}"
		showHeader="true" style="min-width: 100%;">
		@if (!isMobile) {
		<ng-template #template let-dataSource="">
			<div class="ejs-listview-item listview-datapoint">
				<span class="detail">
					<div class="alignRow name">
						<span>Event Text:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.OfflineEventText}}</b></span>
					</div>
					<div class="alignRow name">
						<span>Timestamp:&nbsp;</span>
						<span
							style="margin-right: var(--default-margin);"><b>{{convertEpoch(dataSource.TimeStamp)}}</b></span>
					</div>
				</span>
				<div class="me-auto"></div>
				<span class="detail" style="padding: 1em;">
					<button mat-raised-button (click)="goToEvent(dataSource)" class="app-icon--goto">
						<mat-icon />
						<span>View</span>
					</button>
				</span>
			</div>
		</ng-template>
		}
	</ejs-listview>
</ng-template>